import { Bin, Listing } from "../../atomic_components/types";
import { TopListingActionTypes, SearchTextActionTypes } from "../action-types/index";
import { TopListingAction } from "../actions-interface/index";

const initialState : Listing[]= [];

const topListingsReducer = (
  state: Listing[] = initialState,
  action: TopListingAction
) => {
  switch (action.type) {
    case TopListingActionTypes.ADD_TOP_LISTINGS:
        // console.log(action.payload);
      return [...state, ...action.payload];
    case TopListingActionTypes.RESET_TOP_LISTINGS:
      return [];

    case TopListingActionTypes.UPDATE_TOP_LISTING_DETAILS:
      console.log("inside update_listing_details");
      return state.map(l => (l.sku_id === action.actionOnSku ? action.listingPayload : l));
    case TopListingActionTypes.UPDATE_TOP_LISTINGS:
        const binList : Bin[] =  action.binsPayload; 
        const sumOfAvailableQuantities: number = binList.reduce(
          (accumulator, bin) => accumulator + bin.available_quantity,
          0
        );
        const temp =  state.map(item => {
          if (item.sku_id === action.actionOnSku) {
            return { ...item, available_quantity: sumOfAvailableQuantities, bins:binList}; // Set quantity to 10 as an example
          }
          return item;
        });
        console.log(temp);

        return temp;
    default:
      return state;
  }
};
export default topListingsReducer;
